import { baseurl } from "../../api";
import authenticatedAxios from "../../authenticatedAxios";

// Get all or single language
export const getLanguages = async (params = null, id = null) => {
  if (id) {
    const response = await authenticatedAxios.get(`${baseurl}localization/languages/?id=${id}`);
    return response.data?.data || null;
  } else {
    const response = await authenticatedAxios.get(`${baseurl}localization/languages/`, {
      params,
    });
    return response.data?.data || [];
  }
};

// Add language
export const addLanguage = async (formValues) => {
  const response = await authenticatedAxios.post(`${baseurl}localization/languages/`, formValues);
  if (response.data.response_code !== 1) {
    throw new Error(response.data.message || "Something went wrong!");
  }
  return response.data;
};

// Edit language
export const editLanguage = async (id, formValues) => {
  const response = await authenticatedAxios.put(
    `${baseurl}localization/languages/?id=${id}`,
    formValues
  );
  if (response.data.response_code !== 1) {
    throw new Error(response.data.message || "Something went wrong!");
  }
  return response.data;
};

// Delete language
export const deleteLanguage = async (id) => {
  const response = await authenticatedAxios.delete(`${baseurl}localization/languages/?id=${id}`);
  if (response.status < 200 || response.status >= 300) {
    throw new Error("Failed to delete language");
  }
  return response.data;
};

// Archive single language
export const archiveLanguage = async (id) => {
  const response = await authenticatedAxios.get(`${baseurl}localization/languages/archive/?id=${id}`);
  if (response.status < 200 || response.status >= 300) {
    throw new Error("Failed to archive language");
  }
  return response.data;
};

// Archive multiple languages
export const archiveLanguagesBulk = async (idList) => {
  const response = await authenticatedAxios.post(`${baseurl}localization/languages/archive/`, {
    id_list: idList,
  });
  if (response.status < 200 || response.status >= 300) {
    throw new Error("Failed to archive selected languages");
  }
  return response.data;
};
